import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { StartAutomappingRequestSchema } from '../shared/schemas/automapping.js';

export type { StartAutomappingRequest } from '../shared/schemas/automapping.js';

export const startAutomapping = defaultClient.mutation({
  url: 'omni-trafficking/v1/tracker-mappings/automapping/' as const,
  method: 'POST',
  responseSchema: z.object({}),
  processResponse(data) {
    return data;
  },
  requestSchema: StartAutomappingRequestSchema,
  querySchema: z.object({
    settingsId: z.string(),
  }),
  snakeCaseQueryParams: true,
});
